import { render, staticRenderFns } from "./MiniKaskoPaymentModal.vue?vue&type=template&id=764f08b6&scoped=true&"
import script from "./MiniKaskoPaymentModal.vue?vue&type=script&lang=js&"
export * from "./MiniKaskoPaymentModal.vue?vue&type=script&lang=js&"
import style0 from "./MiniKaskoPaymentModal.vue?vue&type=style&index=0&id=764f08b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764f08b6",
  null
  
)

export default component.exports